import { Container, Flex, Paper, Text, Title } from "@mantine/core";

export default function PasswordResetMailSent() {
  return (
    <Container fluid mt="4rem">
      <Flex justify="center">
        <Paper shadow="sm" p="lg" withBorder w="40rem" maw="40rem">
          <Title order={4}>E-Mail gesendet</Title>
          <Text>
            Wir haben Ihnen eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts geschickt. Bitte prüfen Sie Ihren Spam-Ordner, falls
            Sie die Nachricht nicht finden.
          </Text>
        </Paper>
      </Flex>
    </Container>
  );
}
